import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, Body>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments/${body.tournamentId}/matches/${body.matchId}/swap-knockout-teams`,
      method: 'POST',
      body: body.body,
    }),
  });

interface Body {
  tournamentId: number;
  matchId: number;
  body: {
    current_team_id: number;
    target_team_id: number;
    round: string;
  };
}

interface Response {
  data: {
    message: string;
    code: number;
  };
}
